(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/widgets/casino-game-list/assets/javascripts/jackpot-updater.js') >= 0) return;  svs.modules.push('/widgets/casino-game-list/assets/javascripts/jackpot-updater.js'); "use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

(function (svs) {
  'use strict';

  svs.widget = svs.widget || {};
  svs.widget.casino_game_list = svs.widget.casino_game_list || {};

  var JackpotUpdater = function () {
    function JackpotUpdater(el) {
      _classCallCheck(this, JackpotUpdater);

      var jackpotId = String(el.data('jackpotid'));
      var supplier = el.data('supplier');
      this.jackpotAmount = el.data('jackpotamount');
      this.el = el;
      var jackpotSocketUrl = "/casino/lobby/jackpot/".concat(jackpotId.toLowerCase(), "?supplier=").concat(supplier);
      svs.core.socket.subscribe(jackpotSocketUrl, this.update, this);
    }

    _createClass(JackpotUpdater, [{
      key: "update",
      value: function update(data) {
        if (data.jackpot && data.jackpot.amount && this.jackpotAmount !== data.jackpot.amount) {
          this.el.html(Handlebars.helpers.formatJackpot(data.jackpot.amount, this.jackpotAmount));
          this.jackpotAmount = data.jackpot.amount;
        }
      }
    }]);

    return JackpotUpdater;
  }();

  svs.widget.casino_game_list.JackpotUpdater = JackpotUpdater;
})(svs);
 })(window);